"use client";

import React, { useState } from "react";
import Image from "next/image";
import { User } from "lucide-react";

import { cn } from "@/lib/utils";

interface AvatarCirclesProps {
  className?: string;
  numPeople?: number;
  avatarUrls: string[];
}

const AvatarCircles = ({
  numPeople,
  className,
  avatarUrls,
}: AvatarCirclesProps) => {
  const [errorIndexes, setErrorIndexes] = useState<boolean[]>(
    Array(avatarUrls.length).fill(false)
  );

  const handleError = (index: number) => {
    setErrorIndexes((prev) => {
      const updated = [...prev];
      updated[index] = true;
      return updated;
    });
  };

  return (
    <div className={cn("z-10 flex -space-x-4 rtl:space-x-reverse", className)}>
      {avatarUrls.map((url, index) =>
        errorIndexes[index] ? (
          <div
            key={index}
            className='h-10 w-10 flex items-center justify-center rounded-full border-2 border-black bg-gray-500'
          >
            <User className='h-6 w-6' />
          </div>
        ) : (
          <Image
            key={index}
            className='h-10 w-10 rounded-full border-2 border-black'
            src={url}
            width={40}
            height={40}
            alt={`Avatar ${index + 1}`}
            unoptimized
            onError={() => handleError(index)}
          />
        )
      )}
      <a
        className='flex h-10 w-10 items-center justify-center rounded-full border-2 border-white bg-black text-center text-xs font-medium text-white hover:bg-gray-600 dark:border-gray-800 dark:bg-white dark:text-black'
        href=''
      >
        +{numPeople}
      </a>
    </div>
  );
};

export { AvatarCircles };
